import { render, staticRenderFns } from "./CrewChanges.vue?vue&type=template&id=65dd2822"
import script from "./CrewChanges.vue?vue&type=script&lang=js"
export * from "./CrewChanges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports